<div class="toggle-wrapper">
  <div class="flex items-center gap-1">
    <h3>
      {{
        '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.INTELLIGENT_HEAT_CONTROL.TITLE' | translate
      }}
    </h3>
  </div>

  <ng-container *ngFor="let entry of channelEntries">
    <div class="flex flex-row items-center gap-4">
      <p>
        {{ '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.SUPPLY_CHANNEL' | translate }}
        {{ ' ' + entry.channelNumber }}
      </p>
      <mat-slide-toggle
        class="flex-grow"
        #ftdcToggle
        gtm="onToggle"
        gtmAction="Intelligent Heat Control supply channel toggle"
        gtmCategory="singleRoomControl"
        [disabled]="!(entry.feature | executable: featureCommands.setActive)"
        [checked]="entry.feature | value2: featurePropertyKey.active"
        (change)="onToggleChange(ftdcToggle, entry.feature)"
      ></mat-slide-toggle>
    </div>
  </ng-container>

  <p>
    {{
      '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.INTELLIGENT_HEAT_CONTROL.DESCRIPTION'
        | translate
    }}
  </p>
</div>
